export default __webpack_public_path__ + "static/21-d195ea6d1842633e867a03b0e3505c96.jpg";